import { useState } from 'react';

import BlueprintDemoModalContents from 'dashboard/components/BlueprintDemoModalContents';
import { ModalContainer } from 'dashboard/layouts/ModalLayout';
import {
  Blueprint,
  BlueprintPreviewMap,
  BlueprintServerMetadata,
} from 'dashboard/models/blueprint';
import { BuilderPreviewMap } from 'dashboard/models/inquiry-template';
import { Organization } from 'dashboard/models/organization';
import { OrganizationPlan } from 'dashboard/models/organization-plan';

import BlueprintsAllModalContents from './BlueprintsAllModalContents';

export interface BlueprintsAllModalProps {
  previouslyUsedBlueprints: Blueprint[];
  blueprintsCatalogServer: BlueprintServerMetadata[];
  blueprintPreviews: BlueprintPreviewMap;
  inquiryTemplateBuilderPreviews: BuilderPreviewMap;
  organization: Organization;
  currentOrganizationPlan: OrganizationPlan;
  handleLoadBlueprintPreview: (blueprintKey: string) => Promise<void>;
  handleLoadInquiryTemplateBuilderPreview: (builderName: string) => Promise<void>;
  createBlueprint: (blueprintKey: string) => void;
  closeModal: () => void;
}

const BlueprintsAllModal = ({
  previouslyUsedBlueprints,
  blueprintsCatalogServer,
  blueprintPreviews,
  inquiryTemplateBuilderPreviews,
  organization,
  currentOrganizationPlan,
  handleLoadBlueprintPreview,
  handleLoadInquiryTemplateBuilderPreview,
  createBlueprint,
  closeModal,
}: BlueprintsAllModalProps) => {
  const [currentScreen, setCurrentScreen] = useState('start');
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const [blueprintKeyForPreview, setBlueprintKeyForPreview] = useState<string>(null);

  return (
    <ModalContainer size='xl'>
      {currentScreen === 'start' && (
        <BlueprintsAllModalContents
          previouslyUsedBlueprints={previouslyUsedBlueprints}
          blueprintsCatalogServer={blueprintsCatalogServer}
          organization={organization}
          currentOrganizationPlan={currentOrganizationPlan}
          createBlueprint={createBlueprint}
          toBlueprintPreview={(blueprintKey) => {
            setBlueprintKeyForPreview(blueprintKey);
            setCurrentScreen('blueprint-preview');
          }}
          closeModal={closeModal}
        />
      )}
      {currentScreen === 'blueprint-preview' && (
        <BlueprintDemoModalContents
          blueprintKey={blueprintKeyForPreview}
          blueprintsCatalogServer={blueprintsCatalogServer}
          blueprintPreviews={blueprintPreviews}
          inquiryTemplateBuilderPreviews={inquiryTemplateBuilderPreviews}
          isBlueprintAddedToSandbox={false}
          handleLoadBlueprintPreview={handleLoadBlueprintPreview}
          handleLoadInquiryTemplateBuilderPreview={handleLoadInquiryTemplateBuilderPreview}
          toPreviousScreen={() => setCurrentScreen('start')}
          closeModal={closeModal}
        />
      )}
    </ModalContainer>
  );
};

export default BlueprintsAllModal;
